<template>
  <div :class="`slider ${height}`">
    <div class="line" />
    <div class="subline inc" />
    <div class="subline dec" />
  </div>
</template>

<script>
const props = {
  height: {
    type: String,
    required: false,
    default: "h-2",
  },
};

export default {
  props,
};
</script>

<style>
.slider {
  @apply absolute w-full overflow-x-hidden rounded;
}

.line {
  @apply absolute h-full w-full rounded bg-gray-500 opacity-40;
}

.subline {
  @apply absolute h-full rounded bg-gray-600;
}

.inc {
  animation: increase 2s infinite;
}

.dec {
  animation: decrease 2s 0.5 infinite;
}

@keyframes increase {
  from {
    left: -5%;
    width: 5%;
  }
  to {
    left: 130%;
    width: 100%;
  }
}

@keyframes decrease {
  from {
    left: -80%;
    width: 80%;
  }
  to {
    left: 110%;
    width: 10%;
  }
}
</style>
